module.exports = __webpack_public_path__ + "img/5-1.85db4ef7.svg";